import React, { useEffect, useState } from 'react';
import { func, string, object, bool } from 'prop-types';
import SearchCriteriaComponent from '../../ui-components/core-pricing-component/search-criteria-component/search-criteria-component.jsx';
import { getHostCarrierCode } from '../../utils/common-util.js';
import { toastWarn } from '../../utils/toasts.js';
import { faresSearchCriteria } from '../core-pricing-fares/__mocks__/faresSearchCriteria.js';
import FaresResultScreen from './fares-result-table.jsx';

const CorePricingFares = ({
   updateParentSearchCriteria,
   loadTime,
   selectedSearchCriteria,
   isExistingCriteria,
}) => {
   const [constructedFaresSearchQuery, setConstructedFaresSearchQuery] =
      useState({});
   const [specifiedFaresSearchQuery, setSpecifiedFaresSearchQuery] = useState(
      {}
   );
   const [abortSearch, setAbortSearch] = useState(false);
   const [productTypeConfig, setProductTypeConfig] = useState({
      isConstructedFare: false,
      isSpecifiedFare: false,
   });

   const handleValidationError = (error) => toastWarn(error);
   const handleStopSearchRequest = () => setAbortSearch(true);

   const handleSearchCriteriaSubmit = (
      constructedFaresPayload,
      specifiedFaresPayload,
      isConstructed,
      isSpecified
   ) => {
      setProductTypeConfig({
         isConstructedFare: isConstructed,
         isSpecifiedFare: isSpecified,
      });
      setConstructedFaresSearchQuery({
         ...constructedFaresPayload,
         hostCarrier: getHostCarrierCode(),
         latestLoadTransmission: loadTime,
      });
      setSpecifiedFaresSearchQuery({
         ...specifiedFaresPayload,
         hostCarrier: getHostCarrierCode(),
         latestLoadTransmission: loadTime,
      });
      setAbortSearch(false);
   };

   useEffect(() => {
      const distributionGroupNumbers = sessionStorage.getItem(
         'distributionNumbers'
      );

      if (distributionGroupNumbers) {
         setSpecifiedFaresSearchQuery({
            distributions: [
               {
                  key: 'dgNumber',
                  operator: '=',
                  value: distributionGroupNumbers,
               },
            ],
            hostCarrier: sessionStorage.getItem('carrierCode'),
            latestLoadTransmission: loadTime,
            productType: 'I',
         });
         setProductTypeConfig({
            isConstructedFare: false,
            isSpecifiedFare: true,
         });
         sessionStorage.removeItem('distributionNumbers');
      }
   }, [loadTime]);

   return (
      <div className='spark-flex'>
         <SearchCriteriaComponent
            searchCriteriaData={faresSearchCriteria}
            onSubmit={handleSearchCriteriaSubmit}
            onError={handleValidationError}
            onSaveSearchCriteria={updateParentSearchCriteria}
            onStopSearchRequest={handleStopSearchRequest}
            selectedSearchCriteria={selectedSearchCriteria}
            isExistingCriteria={isExistingCriteria}
         />
         <FaresResultScreen
            constructedFaresSearchQuery={constructedFaresSearchQuery}
            specifiedFaresSearchQuery={specifiedFaresSearchQuery}
            abortSearch={abortSearch}
            productType={productTypeConfig}
         />
      </div>
   );
};

CorePricingFares.propTypes = {
   updateParentSearchCriteria: func,
   loadTime: string,
   selectedSearchCriteria: object,
   isExistingCriteria: bool,
};

export default CorePricingFares;
